module.exports = __webpack_public_path__ + "static/media/useCase33x.f76bf85e.png";